export const paymentPeriodPriceMap = new Map([
  ['monthly', { usd: 4.99, kd: 1.5, unitUsd: '$', unitKd: '.د.ك' }],
  ['yearly', { usd: 49, kd: 15, unitUsd: '$', unitKd: '.د.ك' }],
]);
